import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ja';

dayjs.extend(relativeTime);
dayjs.locale('ja');

/**
 * 日付をフォーマット
 */
export const formatDate = (
  date: string | Date | null | undefined,
  format = 'YYYY年MM月DD日'
): string => {
  if (!date) return '';
  return dayjs(date).format(format);
};

/**
 * 日時をフォーマット
 */
export const formatDateTime = (
  date: string | Date | null | undefined,
  format = 'YYYY年MM月DD日 HH:mm'
): string => {
  if (!date) return '';
  return dayjs(date).format(format);
};

/**
 * 相対時間を取得（例：2時間前）
 */
export const formatRelativeTime = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return dayjs(date).fromNow();
};

/**
 * 短い日付フォーマット
 */
export const formatShortDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return dayjs(date).format('MM/DD');
};

/**
 * 月と日をフォーマット
 */
export const formatMonthDay = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return dayjs(date).format('MM月DD日');
};

/**
 * 年齢を計算
 */
export const calculateAge = (birthDate: string | Date | null | undefined): number | null => {
  if (!birthDate) return null;
  const today = dayjs();
  const birth = dayjs(birthDate);
  let age = today.year() - birth.year();
  if (
    today.month() < birth.month() ||
    (today.month() === birth.month() && today.date() < birth.date())
  ) {
    age--;
  }
  return age;
};

/**
 * 日付が過去かどうかを判定
 */
export const isPast = (date: string | Date | null | undefined): boolean => {
  if (!date) return false;
  return dayjs(date).isBefore(dayjs());
};

/**
 * 日付が未来かどうかを判定
 */
export const isFuture = (date: string | Date | null | undefined): boolean => {
  if (!date) return false;
  return dayjs(date).isAfter(dayjs());
};

/**
 * 日付が今日かどうかを判定
 */
export const isToday = (date: string | Date | null | undefined): boolean => {
  if (!date) return false;
  return dayjs(date).isSame(dayjs(), 'day');
};

/**
 * 日付の差分を取得（日数）
 */
export const getDaysDiff = (date1: string | Date, date2: string | Date): number => {
  return Math.abs(dayjs(date1).diff(dayjs(date2), 'day'));
};

/**
 * 月の開始日を取得
 */
export const getMonthStart = (date: string | Date = new Date()): Date => {
  return dayjs(date).startOf('month').toDate();
};

/**
 * 月の終了日を取得
 */
export const getMonthEnd = (date: string | Date = new Date()): Date => {
  return dayjs(date).endOf('month').toDate();
};

/**
 * 週の開始日を取得（月曜始まり）
 */
export const getWeekStart = (date: string | Date = new Date()): Date => {
  return dayjs(date).startOf('week').add(1, 'day').toDate(); // 月曜始まり
};

/**
 * 週の終了日を取得（日曜終わり）
 */
export const getWeekEnd = (date: string | Date = new Date()): Date => {
  return dayjs(date).endOf('week').add(1, 'day').toDate(); // 日曜終わり
};